import { useEffect } from "react";
import { Link } from "react-router-dom";

//images
import googleicon from "../../assets/images/icon/google.png";
import twitter from "../../assets/images/icon/twitter.png";
import Microsoft from "../../assets/images/icon/Microsoft.png";

import {
  googlewithlogin,
  microsoftwithlogin,
  twitterwithlogin,
} from "../../store/user/userThunk";

const AuthLayout = ({ authTitle, helpText, bottomLinks, children, isOtpStep }) => {
  useEffect(() => {
    if (document.body) {
      document.body.classList.add("hero-bg", "tracking-wide");
    }

    return () => {
      if (document.body) {
        document.body.classList.remove("hero-bg", "tracking-wide");
      }
    };
  }, []);

  let GoogleWithLogin = async () => {
    await googlewithlogin();
  };

  let twitterWithLogin = async () => {
    await twitterwithlogin();
  };

  let MicrosoftWithLogin = async () => {
    await microsoftwithlogin();
  };

  return (
    <>
      <div className="min-h-screen flex items-center justify-center">
        <div className="container">
          <div>
            <div className="bg-formbox shadow rounded mb-6">
              <div className="grid md:grid-cols-12">
                <div className="bg-form shadow-md p-12 rounded-s xl:col-span-5 md:col-span-6">
                  <div className="mb-12">
                    {/* <Link to="/">
                      <img src={logoDark} alt="logo-img" className="h-8" />
                    </Link> */}
                  </div>
                  <h6 className="text-base/[1.6] font-semibold text-gray-600 mb-0 mt-4">
                    {authTitle}
                  </h6>
                  <p className="text-gray-500 text-sm/[1.6] mt-1 mb-6">
                    {helpText}
                  </p>
                  {children}
                </div>

                {/* Replaced Swiper with Social Login Buttons */}
                <div className="hidden md:flex xl:col-span-7 md:col-span-6 items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
                  <div className="w-full max-w-md px-8">
                    <div className="text-center mb-8">
                      <h3 className="text-2xl font-bold text-gray-800 mb-2">
                        Quick Sign In
                      </h3>
                      <p className="text-gray-600">
                        Connect with your favorite social platform
                      </p>
                    </div>

                    <div className="space-y-4">
                      {/* Google Login Button */}
                      <button
                        onClick={GoogleWithLogin}
                        className="w-full flex items-center justify-center px-6 py-3 border border-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:shadow-md"
                      >
                        <img src={googleicon} alt="Google" className="w-5 h-5 mr-3" />
                        <span className="text-gray-700 font-medium">
                          Continue with Google
                        </span>
                      </button>

                      {/* Microsoft Login Button */}
                      <button
                        onClick={MicrosoftWithLogin}
                        className="w-full flex items-center justify-center px-6 py-3 border border-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:shadow-md"
                      >
                        <img src={Microsoft} alt="Microsoft" className="w-5 h-5 mr-3" />
                        <span className="text-gray-700 font-medium">
                          Continue with Microsoft
                        </span>
                      </button>

                      {/* Twitter Login Button */}
                      <button
                        onClick={twitterWithLogin}
                        className="w-full flex items-center justify-center px-6 py-3 border border-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:shadow-md"
                      >
                        <img src={twitter} alt="Twitter" className="w-5 h-5 mr-3" />
                        <span className="text-gray-700 font-medium">
                          Continue with Twitter
                        </span>
                      </button>
                    </div>

                    <div className="mt-8 text-center">
                      <div className="relative">
                        <div className="absolute inset-0 flex items-center">
                          <div className="w-full border-t border-gray-300"></div>
                        </div>
                        <div className="relative flex justify-center text-sm">
                          <span className="px-2 bg-gray-50 text-gray-500">
                            Or continue with email
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="mt-6 text-center">
                      <p className="text-xs text-gray-500">
                        By continuing, you agree to our{" "}
                        <Link to="/pages/privacy-policy" className="text-[#50B5FF] hover:underline">
                          Privacy Policy
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>

                {/* Mobile Social Buttons - shown only on small screens */}
                <div className="md:hidden px-6 py-8 bg-gradient-to-br from-blue-50 to-indigo-100">
                  <div className="text-center mb-6">
                    <h4 className="text-lg font-semibold text-gray-800 mb-1">
                      Quick Sign In
                    </h4>
                    <p className="text-sm text-gray-600">
                      Connect with your social platform
                    </p>
                  </div>

                  <div className="space-y-3">
                    {/* Mobile Google Button */}
                    <button
                      onClick={GoogleWithLogin}
                      className="w-full flex items-center justify-center px-4 py-2.5 border border-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                    >
                      <img src={googleicon} alt="Google" className="w-4 h-4 mr-2" />
                      <span className="text-sm text-gray-700 font-medium">
                        Google
                      </span>
                    </button>

                    {/* Mobile Microsoft Button */}
                    <button
                      onClick={MicrosoftWithLogin}
                      className="w-full flex items-center justify-center px-4 py-2.5 border border-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                    >
                      <img src={Microsoft} alt="Microsoft" className="w-4 h-4 mr-2" />
                      <span className="text-sm text-gray-700 font-medium">
                        Microsoft
                      </span>
                    </button>

                    {/* Mobile Twitter Button */}
                    <button
                      onClick={twitterWithLogin}
                      className="w-full flex items-center justify-center px-4 py-2.5 border border-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                    >
                      <img src={twitter} alt="Twitter" className="w-4 h-4 mr-2" />
                      <span className="text-sm text-gray-700 font-medium">
                        Twitter
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {bottomLinks}
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLayout;